import React,{useState} from "react";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { MoveTemplateToFolderPopupProps } from "../email-letter-types";
import CloseIcon from "../../../assets/icons/closeIcon.svg";
import { createNewFolder } from "../../../api/email-letter-templates";
import { AlertComponent } from "../../../common/components";

const MoveTemplateToFolderPopup: React.FC<MoveTemplateToFolderPopupProps> = ({
  isOpen,
  onClose,
  onMove,
  folders = [],
  templateType = "Email",
  fetchFoldersList,
  currentAssignedFolderName
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [isCreateNewFolder, setIsCreateNewFolder] = React.useState(false);
  const [newFolderName, setNewFolderName] = React.useState("");
   const [alertMessage, setAlertMessage] = useState<string | null>(null);
    const [alertType, setAlertType] = useState<
      "error" | "success" | "info" | "warning"
    >("info");
    const [alertOpen, setAlertOpen] = useState<boolean>(false);


  const createNewFolderApi = async () => {
    if (newFolderName.trim() === "") {
      setAlertMessage("Folder name cannot be empty");
      setAlertType("error");
      setAlertOpen(true);
      return;
    }
    try {
      const response = await createNewFolder({
        folderName: newFolderName,
        templateType: templateType,
      });
      if (response?.data?.success === true) {
        onMove?.({
          folder_name: response?.data?.data?.folder_name,
          id: response?.data?.data?.id,
        })
        setNewFolderName("");
        setIsCreateNewFolder(false);
        fetchFoldersList?.();
      }
    } catch (error:any) {
      setAlertMessage(error?.response?.data?.message || "Error creating new folder");
      setAlertType("error");
      setAlertOpen(true);
      console.error("Error creating new folder:", error);
    }
  };

  const handleCreateNewFolder = (e: any) => {
    setNewFolderName(e.target.value);
  };

  const handleClose = () => {
    setIsCreateNewFolder(false);
    setNewFolderName("");
    onClose();
  };
  return (
    <div className="move-template-to-folder-popup-wrapper mass-update-wrapper">
      <Dialog
        open={isOpen}
        aria-labelledby="move-template-dialog-title"
        aria-describedby="move-template-dialog-description"
        className="update-popup-wrapper move-templates-popup"
        slotProps={{
          paper: {
            sx: {
              width: isMobile ? "90%" : "500px", // 90% width on mobile
              maxWidth: "95vw", // prevent overflow
              minHeight: "280px",
              position: "absolute",
            },
          },
        }}
      >
        <DialogTitle id="move-template-dialog-title">
          <div className="header-wrapper">
            <div>{"Move To Folder"}</div>
            <div className="image-wrapper">
              <img src={CloseIcon} className="close-icon" onClick={handleClose} />
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          {folders?.length > 0 && !isCreateNewFolder && (
            <Box className="folder-list">
              {folders?.map((folder) => (
                <Box
                  key={folder?.id}
                  className={`folder-item ${currentAssignedFolderName === folder?.folder_name ? 'active-folder-item' : ''}`}
                  onClick={() => onMove?.(folder)}
                  
                >
                  {folder?.folder_name}
                </Box>
              ))}
            </Box>
          )}
          {isCreateNewFolder && (
            <Box className="new-folder-input-wrapper">
              <label className="input-label">New Folder</label>
              <input
                type="text"
                placeholder="Enter new folder name"
                value={newFolderName}
                onChange={(e) => handleCreateNewFolder(e)}
                className="new-folder-input"
                id="new-folder-input-field"
                maxLength={100}
              />
            </Box>
          )}
        </DialogContent>
        <DialogActions className="button-wrapper">
          {!isCreateNewFolder ? (
            <>
              <Button onClick={handleClose} className="cancel-btn">
                Cancel
              </Button>
              <Button
                onClick={() => {
                  setIsCreateNewFolder(true);
                  setNewFolderName("");
                }}
                className="update-btn new-folder-btn"
              >
                Add New Folder
              </Button>
            </>
          ) : (
            <>
              <Button
                onClick={() => {
                  setIsCreateNewFolder(false);
                  setNewFolderName("");
                }}
                className="cancel-btn"
              >
                Cancel
              </Button>
              <Button
                onClick={() => {
                    // onMove(newFolderName);
                  createNewFolderApi()
                  setIsCreateNewFolder(false);
                }}
                className="update-btn save-and-more-btn"
                disabled={!newFolderName.trim()}
              >
                Save & Move
              </Button>
            </>
          )}
        </DialogActions>
        <AlertComponent
            message={alertMessage}
            type={alertType ?? "info"}
            open={alertOpen}
            onClose={() => setAlertOpen(false)}
        />
      </Dialog>
    </div>
  );
};
export default MoveTemplateToFolderPopup;
